// extracted by mini-css-extract-plugin
export default {"message":"_3JylK","countdown":"_2MFL_","countdown-value":"rj1bd","countdownValue":"rj1bd","countdown-ended":"iiFAE","countdownEnded":"iiFAE"};